import template from './sw-cms-block-vimeo-video.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
